/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  list: [],
  selecting: {},
  filters: {
    id: [],
    status: [1, 2],
  },
  timetables: [],
  pagination: {
    current_page: 1,
    per_page: 20,
    total: 0,
  },
  classesWithoutGroups: [],
  classesWithFilters: [],
};
